import React from "react";
import { Appbar, Drawer } from "..";
import Typography from "@material-ui/core/Typography";
import { Box, Link, Toolbar } from "@material-ui/core";

export default (props) => (
  <React.Fragment>
    <Drawer setMenuPart={props.setMenuPart} isSale={props.isSale} noSaleExplaination={props.noSaleExplaination}>{props.children}</Drawer>
  </React.Fragment>
);
